/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentInferencerPolymorphic } from './ConversationalAgentInferencerPolymorphic';
import {
  ConversationalAgentInferencerPolymorphicFromJSON,
  ConversationalAgentInferencerPolymorphicFromJSONTyped,
  ConversationalAgentInferencerPolymorphicToJSON,
} from './ConversationalAgentInferencerPolymorphic';
import type { ConversationalAgentDataset } from './ConversationalAgentDataset';
import {
  ConversationalAgentDatasetFromJSON,
  ConversationalAgentDatasetFromJSONTyped,
  ConversationalAgentDatasetToJSON,
} from './ConversationalAgentDataset';
import type { ConversationalAgentLanguageEnum } from './ConversationalAgentLanguageEnum';
import {
  ConversationalAgentLanguageEnumFromJSON,
  ConversationalAgentLanguageEnumFromJSONTyped,
  ConversationalAgentLanguageEnumToJSON,
} from './ConversationalAgentLanguageEnum';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface GenerationInputsPolymorphicConversationalAgentGenerationInputs
 */
export interface GenerationInputsPolymorphicConversationalAgentGenerationInputs {
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof GenerationInputsPolymorphicConversationalAgentGenerationInputs
   */
  taskType: TaskTypeEnum;
  /**
   *
   * @type {number}
   * @memberof GenerationInputsPolymorphicConversationalAgentGenerationInputs
   */
  readonly id: number;
  /**
   *
   * @type {ConversationalAgentLanguageEnum}
   * @memberof GenerationInputsPolymorphicConversationalAgentGenerationInputs
   */
  language: ConversationalAgentLanguageEnum;
  /**
   *
   * @type {number}
   * @memberof GenerationInputsPolymorphicConversationalAgentGenerationInputs
   */
  nSamples: number;
  /**
   *
   * @type {ConversationalAgentDataset}
   * @memberof GenerationInputsPolymorphicConversationalAgentGenerationInputs
   */
  readonly seedDataset: ConversationalAgentDataset;
  /**
   *
   * @type {ConversationalAgentInferencerPolymorphic}
   * @memberof GenerationInputsPolymorphicConversationalAgentGenerationInputs
   */
  readonly inferencer: ConversationalAgentInferencerPolymorphic;
}

/**
 * Check if a given object implements the GenerationInputsPolymorphicConversationalAgentGenerationInputs interface.
 */
export function instanceOfGenerationInputsPolymorphicConversationalAgentGenerationInputs(
  value: object,
): value is GenerationInputsPolymorphicConversationalAgentGenerationInputs {
  if (!('taskType' in value) || value['taskType'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('nSamples' in value) || value['nSamples'] === undefined) return false;
  if (!('seedDataset' in value) || value['seedDataset'] === undefined) return false;
  if (!('inferencer' in value) || value['inferencer'] === undefined) return false;
  return true;
}

export function GenerationInputsPolymorphicConversationalAgentGenerationInputsFromJSON(
  json: any,
): GenerationInputsPolymorphicConversationalAgentGenerationInputs {
  return GenerationInputsPolymorphicConversationalAgentGenerationInputsFromJSONTyped(json, false);
}

export function GenerationInputsPolymorphicConversationalAgentGenerationInputsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GenerationInputsPolymorphicConversationalAgentGenerationInputs {
  if (json == null) {
    return json;
  }
  return {
    taskType: TaskTypeEnumFromJSON(json['task_type']),
    id: json['id'],
    language: ConversationalAgentLanguageEnumFromJSON(json['language']),
    nSamples: json['n_samples'],
    seedDataset: ConversationalAgentDatasetFromJSON(json['seed_dataset']),
    inferencer: ConversationalAgentInferencerPolymorphicFromJSON(json['inferencer']),
  };
}

export function GenerationInputsPolymorphicConversationalAgentGenerationInputsToJSON(
  value?: Omit<
    GenerationInputsPolymorphicConversationalAgentGenerationInputs,
    'id' | 'seedDataset' | 'inferencer'
  > | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    task_type: TaskTypeEnumToJSON(value['taskType']),
    language: ConversationalAgentLanguageEnumToJSON(value['language']),
    n_samples: value['nSamples'],
  };
}
